<template>
  <div class="tops">
    <!-- 顶部-start -->
    <div class="toptitle">
      <div class="awidth">
        <div class="left-tiele" @click="BackChannel()">
          <img src="@/assets/icon/home.png" alt=""> 返回系统首页
        </div>
        <div class="right-tiele">
          您好！欢迎来到鸿雁-归创通桥渠道数据综合管理系统
          <div style=" display: inline-block;margin-left: 20px;  margin-right: 20px; color: rgba(255, 255, 255, 0.247);">|
          </div>
          <div style=" display: inline-block;" @click="topdownclick" v-click-outside="clickOutSide">
          {{ TrueName }}
          &nbsp;<img src="../assets/icon/top-icon.png" alt="" style="vertical-align: middle;" :class="[ downboo ? 'img' : 'imgs'  ]"></div>
          <transition name="el-zoom-in-top">
            <div class="downbooshow" v-show="downboo ">
              <div class="downz" v-for="(item , index) of munscd" :key="index" @click="clickdownz(index)">
                <div style="font-size: 14px;width: 80%;height: 44px;border-bottom: 1px solid #F0F0F0;line-height: 40px;">{{ item.title }}</div>
              </div>
            </div>
          </transition>
        </div>
      </div>

    </div>
    <!-- 顶部-end @click="bottomTop"-->
    <div class="bottom-top" >
      <div class="bottoms">
        <div class="bottom">
          <span class="title" @click="HomePage">数据管理</span>
          <span style="margin-top: 5px;margin-left: 5px;color: rgb(11 47 115);">{{ $store.state.versionData ? $store.state.versionData.SystemRemark : '' }}</span>
          <div v-for="(item,index) of topdatalist" :key="index" class="topList">
            <div class="title-list" @click="topclick(item)" :class="[{ 'avitce' : item.NodeID == ischage }]">
              <span class="titles" style="color:#333333 ; font-size: 16px;">{{ item.NodeName }}</span>
              <div class="avitce-state"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <DialogFrom width="640px" title="修改密码" :dialogVisible="dialogVisiblesUpdatePassWord" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdata">
          <Commondropdownlist :key="index" ref="updatepass" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
          </Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
  </div>
</template>

<script>
import { ChangePass } from '@/api/home'
import DialogFrom from '../components/dialog-from.vue'
import Commondropdownlist from '../components/common-dropdownlist.vue'
import app from '../config/confighttp'
export default {
  props: {

  },
  components: {
    DialogFrom,
    Commondropdownlist
  },
  data() {
    return {
      TrueName: '',
      activeIndex2: 'home',
      ischage: sessionStorage.getItem("ischage") || "-1",//上菜单状态
      downboo: false,
      dialogVisiblesUpdatePassWord: false,
      http_Name: '',
      downboostate: 1,
      munscd: [
        { title: "修改密码" },
        { title: "退出登录" },
        { title: "系统版本：V3.0.0" },
      ],
      topdatalist: [],
      fromdata: [
        {
          inputdata: '',
          title: '原密码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'password',
          inputtype: 'input',
          width: '400px',
          disabled: false,
          lablewith: '110px',
        },
        {
          inputdata: '',
          title: '新密码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'password',
          inputtype: 'input',
          width: '400px',
          lablewith: '110px',

        },
        {
          inputdata: '',
          title: '确认新密码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'password',
          inputtype: 'input',
          width: '400px',
          lablewith: '110px',

        },
      ]
    }
  },
  created() {
    this.http_Name = app.http_Name
    if (localStorage.getItem("comm-token") && localStorage.getItem("MenusData")) {
      this.userInfoMun()
    } else if (localStorage.getItem("comm-token")) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      setTimeout(() => {
        loading.close();
        this.userInfoMun()
      }, 500);

    }
  },
  beforeMount() {
    // this.$fishkefu.init()
  },
  mounted() {
    this.TrueName = this.$store.state.userInfo.TrueName
    //console.log(this.$store.state.userInfo.TrueName, "store")
    // this.$fishkefu.Config()
  },
  methods: {
    clickOutSide(){
      this.downboo = false
    },
    // bottomTop() {
    //   this.downboo = false
    // },
    async changePass(domRef) {
      let {
        code,
        message
      } = await ChangePass({
        password: this.$md5(domRef[0].modelvalue).toUpperCase(),
        newPassword: this.$md5(domRef[1].modelvalue).toUpperCase(),
        secPassword: this.$md5(domRef[2].modelvalue).toUpperCase()
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.dialogVisiblesUpdatePassWord = false
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    cancel() {
      this.dialogVisiblesUpdatePassWord = false
    },
    dialogOK() {
      this.changePass(this.$refs.updatepass)
    },
    userInfoMun() {
      this.topdatalist = []
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        this.topdatalist.push(item)
      })
      console.log(this.topdatalist, 'this.topdatalist');
    },
    go(router) {
      this.$router.push({
        name: router
      });
    },

    topclick(item) {
      if (item.NodeID != this.ischage) {
        this.ischage = item.NodeID
        sessionStorage.setItem("ischage", this.ischage)
      }
	  
      if (item.NodeID == '9'||item.NodeID == '24') {
        this.$router.push({
          path: item.Nodes[0].Nodes[0].Path
        })
      } else {
        this.$router.push({
          path: item.Nodes[0].Path
        })
      }
      let is = 0
      // 修改左侧菜单栏的状态
      sessionStorage.setItem("ischages", is)
      // this.$emit('topclick', par)
      // //console.log(state, "index")

      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    handleSelect(key, keyPath) {
      // //console.log(key, keyPath);
    },
    topdownclick() {
      this.downboostate = 2
      this.downboo = !this.downboo
    },
    clickdownz(index) {
      this.downboo = false
      this.downboostate = 2
      if (index == 1) {

        const loading = this.$loading({
          lock: true,
          text: '正在注销登录...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        this.$fishkefu.closeSdk()
        setTimeout(() => {
          loading.close();
          this.$store.commit("OUT_LOGINI")
          this.$router.push({
            name: 'CodeLoginPage'
          })
          this.$message({
            type: 'success',
            message: '注销成功'
          });
        }, 1000);
      }
      if (index == 0) {
        this.dialogVisiblesUpdatePassWord = true
      }
    },
    HomePage() {
      this.$router.push({
        name: "homePage"
      })
      this.ischage = -1
    },
    BackChannel() {
      if (this.$store.state.QDstate) {
        this.$router.push({
          path: "/homeCom/HomePage?NodeID=60",
        });
      }
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log();
        if (to.path.split("/")[1] == "SMS") { 
          this.ischage = 16
        }
        if (to.path.split("/")[1] == "BA" ) {
          this.ischage = 9
        }
        if (to.path.split("/")[1] == "WMS") {
          this.ischage = 18
        }
        if ( to.path.split("/")[1] == "Report") {
          this.ischage = 24
        }
        if ( to.path.split("/")[1] == "UA") {
          this.ischage = 1
        }
        if ( to.path.split("/")[1] == "Helper") {
          this.ischage = 31
        }
        if (to.path == '/homePage') {
          this.ischage = -1
        }
        //console.log(to.path, 'p');
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="less">
.el-menu-item:hover {
  background-color: red;
  color: white;
}
</style>
<style scoped="scoped" lang="less">
@import "../style/mixin.less";

.avitce-state {
  height: 4px;
  position: relative;
  bottom: 6px;
  border-radius: 2px;

  // border-bottom: 4px solid #0b2f73;
}

.avitce {
  .avitce-state {
    background: #0b2f73;
    transition: 0.5s linear;
  }

  .title {
    color: #0b2f73;
  }
}

.tops {
  // width: 100%;
  // height: 100%;
  user-select: none;
  .toptitle {
    .awidth {
      .zwidth(100%);
      background-color: #00266d;
    }

    height: 32px;
    background-color: #00266d;
    // overflow: hidden;
    line-height: 32px;
    font-size: 12px;
    color: #fff;
  }

  .bottom-top {
    width: 100%;
    height: 64px;
    background-color: #fff;
    line-height: 64px;
    // border: 1px solid red;
    cursor: pointer;
    .bottoms {
      .zwidth(100%);
    }
    .bottom {
      width: 1200px;
      background-color: #fff;
      height: 64px;
      display: flex;

      .title-list {
        margin-left: 80px;
        .titles {
          font-size: 15px;
          color: #8c8c8c;
          text-align: center;
        }
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #0b2f73;
      }
    }
  }

  .left-tiele {
    display: inline-block;
    float: left;
    cursor: pointer;
    width: 112px;
    height: 24px;
    background: #e71d43;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    line-height: 24px;
    font-size: 12px;
    margin-top: 3.5px;

    img {
      width: 17px;
      height: 17px;
      vertical-align: middle;
      margin-left: 8px;
      margin-right: 4px;
      padding-bottom: 2px;
    }
  }

  .right-tiele {
    // width: 157px;
    display: inline-block;
    float: right;
    cursor: pointer;
    font-family: -webkit-body;
    text-align: right;
    position: relative;
  }
}

.downbooshow {
  width: 170px;
  height: 157px;
  background-color: rgb(255 255 255);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  position: absolute;
  left: 260px;
  z-index: 9999999;
  overflow: hidden;
  text-align: left;
}
.downbooshows {
  width: 170px;
  height: 0px;
  background-color: #ffffff;
  position: absolute;
  left: 260px;
  z-index: 9999999;
  overflow: hidden;
  text-align: left;
}
.img {
  transform: rotate(0deg);
  transition: all 0.5s;
}
.imgs {
  transform: rotate(180deg);
  transition: all 0.5s;
}

.downz {
  // width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-around;
  color: #333333;
}
.downz:hover {
  background-color: #fef3f5;
  color: #e71d43;
}
.topList {
  display: flex;
}
</style>
